export const Alphanumeric = (str) => {
    const rgx_alphanumeric = /[!#$%^&*()_+\-=\[\]{};':"\\|,<>\/?]/;
    return rgx_alphanumeric.test(String(str).toLowerCase())
}
